import editGroupFooterButtonsUrl from './editGroupFooterButtons.html';
export default {
  controllerAs: 'ctrl',
  templateUrl: editGroupFooterButtonsUrl,
  bindings: {
    form: '<',
    submit: '&',
    cancel: '&',
    useRegularButton: '<',
  },
};
